import "./Leadership.css";
import React, { useState, useEffect, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Chairman from "../images/Chairman.jpg";
import MainBg from "../images/Leadership main bg.jpg";
import Ceo from "../images/Ojiromayo.jpg";
import ED from "../images/Abayomi.jpg";
import Internal from "../images/Yomi.jpg";
import InternalAud from "../images/Segun.jpg";
import RiskMMng from "../images/Kingsley.jpg";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import Footer from "./footer";
import AOS from 'aos';

const client = new ApolloClient({
  link: new HttpLink({
    uri: "https://pensure-cms.inspireleadership.biz/graphql",
  }),
  cache: new InMemoryCache(),
});

const Leadership = () => {
  window.scrollTo(0, 0);

  const [heroBanner, setHeroBanner] = useState([]);
  const [heroMobile, setHeroMobile] = useState([]);
  const [board, setBoard] = useState([]);
  const [management, setManagement] = useState([]);


                      useEffect( () => {
                                 AOS.init({
                                    offset: 0,
                                    duration: 1000,
                                    once: true
                             });
                                              
                                                  
                             }, [])

  useEffect(() => {
    client
      .query({
        query: gql`
          query NewQuery {
            pages(first: 100) {
              nodes {
                structure {
                  board {
                    firstname
                    lastname
                    image {
                      mediaItemUrl
                    }
                    bio
                    role
                  }
                  hero {
                    buttonLink
                    buttonName
                    caption
                    description
                    heading
                    image {
                      mediaItemUrl
                    }
                  }
                  heromobile {
                    buttonLink
                    buttonName
                    caption
                    heading
                    image {
                      mediaItemUrl
                    }
                  }
                  management {
                    bio
                    firstname
                    lastname
                    role
                    image {
                      mediaItemUrl
                    }
                  }
                }
              }
            }
          }
        `,
      })
      .then((result) => {
        console.log(result);
        setHeroBanner(result.data.pages.nodes[15].structure.hero);
        setHeroMobile(result.data.pages.nodes[15].structure.heromobile);
        setBoard(result.data.pages.nodes[15].structure.board);
        setManagement(result.data.pages.nodes[15].structure.management);
      });
  }, []);

  let heroBannerDisplay;
  let heroMobileBannerDisplay;

  if (heroBanner.length > 0) {
    heroBannerDisplay = heroBanner.map((banner, i) => (
      <div className="leadership-cover">
        <img className="leadership-bg" src={banner.image.mediaItemUrl} />
        <div className="leadership-content">
          <div className="abt-text-ldr ldr-txt">
            <h1 className="lead-h1 "  data-aos="zoom-in" data-aos-delay="200">{banner.heading}</h1>
            <p id="grey-ldr" className="grey-p"  data-aos="fade-up" data-aos-delay="200">
              {banner.caption}
            </p>
            <a
              className="btn-trns"
              href={banner.buttonLink}
              data-target="_blank"
               data-aos="fade-up" data-aos-delay="200"
            >
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (heroMobile.length > 0) {
    heroMobileBannerDisplay = heroMobile.map((banner, i) => (
      <div className="leadership-cover">
        <img className="leadership-bg" src={banner.image.mediaItemUrl} />
        <div className="leadership-content">
          <div className="abt-text-ldr ldr-txt">
            <h1 className="lead-h1"  data-aos="zoom-in" data-aos-delay="200">{banner.heading}</h1>
            <p id="grey-ldr" className="grey-p"  data-aos="fade-up" data-aos-delay="200">
              {banner.caption}
            </p>
            <a
              className="btn-trns"
              href={banner.buttonLink}
              data-target="_blank"
               data-aos="fade-up" data-aos-delay="200"
            >
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  const BoardMembers = [
    {
      id: 1,
      img: Chairman,
      name: "Olusegun Aganga",
      position: "Chairman",
      description:
        "Olusegun Aganga is a seasoned leader with over 25 years of experience in the financial sector. As Chairman, he brings strategic vision and governance expertise to Leadway Pensure.",
      description1:
        "Prior to joining Leadway Pensure, Olusegun served as the Minister of Finance and Coordinating Minister for the Economy in Nigeria, where he played a pivotal role in economic reforms and fiscal policy development.",
      description2:
        "Olusegun holds an MBA from Harvard Business School and a Bachelor's degree in Law from the University of Lagos. His leadership is characterized by a commitment to transparency, innovation, and sustainable growth.",
    },
    {
      id: 2,
      img: Ceo,
      name: "Olusakin Labeodan",
      position: "Managing Director/CEO",
      description:
        "Olusakin Labeodan is a dynamic leader with over 20 years of experience in the financial services industry. As Managing Director/CEO, he drives operational excellence and strategic growth at Leadway Pensure.",
      description1:
        "Prior to joining Leadway Pensure, Olusakin served as the Chief Financial Officer at a major Nigerian bank, where he led financial planning and risk management initiatives.",
      description2:
        "Olusakin holds an MBA from Harvard Business School and a Bachelor's degree in Law from the University of Lagos. His leadership is characterized by a commitment to transparency, innovation, and sustainable growth.",
    },
    {
      id: 3,
      img: ED,
      name: "Abayomi Adesope",
      position: "Executive Director/Operations",
      description:
        "Abayomi Adesope is a dynamic leader with over 20 years of experience in the financial services industry. As Managing Director/CEO, he drives operational excellence and strategic growth at Leadway Pensure.",
      description1:
        "Prior to joining Leadway Pensure, Abayomi served as the Chief Financial Officer at a major Nigerian bank, where he led financial planning and risk management initiatives.",
      description2:
        "Abayomi holds an MBA from Harvard Business School and a Bachelor's degree in Law from the University of Lagos. His leadership is characterized by a commitment to transparency, innovation, and sustainable growth.",
    },
  ];
  const ManagementTeam = [
    {
      id: 10,
      img: Internal,
      name: "Yomi Oduguwa",
      position: "Internal Control",
      description:
        "Yomi Oduguwa is a seasoned leader with over 25 years of experience in the financial sector. As Internal Audit, he brings strategic vision and governance expertise to Leadway Pensure.",
      description1:
        "Prior to joining Leadway Pensure, Yomi served as the Minister of Finance and Coordinating Minister for the Economy in Nigeria, where he played a pivotal role in economic reforms and fiscal policy development.",
      description2:
        "Yomi holds an MBA from Harvard Business School and a Bachelor's degree in Law from the University of Lagos. His leadership is characterized by a commitment to transparency, innovation, and sustainable growth.",
    },
    {
      id: 11,
      img: InternalAud,
      name: "Segun Awode",
      position: "Managing Director/CEO",
      description:
        "Segun Awode is a dynamic leader with over 20 years of experience in the financial services industry. As Managing Director/CEO, he drives operational excellence and strategic growth at Leadway Pensure.",
      description1:
        "Prior to joining Leadway Pensure, Segun served as the Chief Financial Officer at a major Nigerian bank, where he led financial planning and risk management initiatives.",
      description2:
        "Segun holds an MBA from Harvard Business School and a Bachelor's degree in Law from the University of Lagos. His leadership is characterized by a commitment to transparency, innovation, and sustainable growth.",
    },
    {
      id: 12,
      img: RiskMMng,
      name: "Kingsley Ugochukwu",
      position: "Executive Director/Operations",
      description:
        "Kingsley Okonkwo is a dynamic leader with over 20 years of experience in the financial services industry. As Executive Director/Operations, he drives operational excellence and strategic growth at Leadway Pensure.",
      description1:
        "Prior to joining Leadway Pensure, Kingsley served as the Chief Financial Officer at a major Nigerian bank, where he led financial planning and risk management initiatives.",
      description2:
        "Kingsley holds an MBA from Harvard Business School and a Bachelor's degree in Law from the University of Lagos. His leadership is characterized by a commitment to transparency, innovation, and sustainable growth.",
    },
  ];

  const LoopBoardMembers = board.map((member, i) => {
    return (
      <React.Fragment key={i}>
        {/* Card */}
        <div
          className="crd card mt-4"
          style={{ width: "354.7px", height: "417px", zIndex: "10" }}
           data-aos="fade-up" data-aos-delay="200"
        >
          <div style={{ padding: "1rem" }}>
            <div
              className="card-img-top"
              style={{
                height: "300px",
                borderRadius: "0.5rem",
                backgroundImage: `url(${member?.image.mediaItemUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "top",
              }}
            ></div>
          </div>

          <div className="card-body d-flex align-items-center justify-content-between">
            <div>
              <h6 className="card-title crd-ttl">
                {member?.firstname + " " + member?.lastname}
              </h6>
              <p
                style={{
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: 14,
                  color: "#3B475A",
                  lineHeight: "160%",
                }}
              >
                {member?.role}
              </p>
            </div>

            <FontAwesomeIcon
              className="chv-dwn-arr"
              data-bs-toggle="modal"
              data-bs-target={`#modal-${i + member?.firstname}`}
              icon={faArrowRight}
              style={{
                color: "#fe7914",
                fontSize: "8px",
                backgroundColor: "#FFEACC",
                padding: "13.5px",
              }}
            />
          </div>
        </div>

        {/* Modal */}
        <div
          className="modal fade"
          id={`modal-${i + member?.firstname}`}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby={`modalLabel-${i + member?.firstname}`}
          aria-hidden="true"
        >
          <div
            id="modal-dialog"
            className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            data-aos="fade-up" data-aos-delay="200"
          >
            <div className="modal-content">
              <div id="modal-header" className="modal-header">
                <h5
                  className="modal-title"
                  id={`modalLabel-${i + member?.firstname}`}
                ></h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body d-flex justify-content-between align-items-start">
                <div
                  id="modal-container"
                  style={{ width: "20%", marginLeft: "20px" }}
                >
                  <img
                    src={member?.image.mediaItemUrl}
                    alt={member?.firstname + " " + member?.lastname}
                    className="modal-img"
                  />
                  <p
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "17.78px",
                      color: "#333333",
                      marginTop: "10px",
                    }}
                  >
                    {member?.firstname + " " + member?.lastname}
                  </p>
                  <p
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 400,
                      fontSize: "15.56px",
                      color: "#333333",
                      marginTop: "10px",
                    }}
                  >
                    {member?.role}
                  </p>
                </div>

                <div
                  className="modal-text-content"
                  style={{ width: "80%", overflowX: "scroll", height: "400px" }}
                >
                  <div class="modal-text">
                    <p>{member?.bio}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  });
  const ManagementStaff = management.map((team, i) => {
    return (
      <React.Fragment key={i}>
        {/* Card */}
        <div
          className="crd card mt-4"
          style={{ width: "354.7px", height: "417px", zIndex: "10" }}
           data-aos="fade-up" data-aos-delay="200"
        >
          <div style={{ padding: "1rem" }}>
            <div
              className="card-img-top"
              style={{
                height: "300px",
                borderRadius: "0.5rem",
                backgroundImage: `url(${team?.image.mediaItemUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "top",
              }}
            ></div>
          </div>

          <div className="card-body d-flex align-items-center justify-content-between">
            <div>
              <h6 className="card-title crd-ttl">
                {team?.firstname + " " + team?.lastname}
              </h6>
              <p
                style={{
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: 14,
                  color: "#3B475A",
                  lineHeight: "160%",
                }}
              >
                {team?.role}
              </p>
            </div>

            <FontAwesomeIcon
              className="chv-dwn-arr"
              data-bs-toggle="modal"
              data-bs-target={`#modal-${i + team?.firstname}`}
              icon={faArrowRight}
              style={{
                color: "#fe7914",
                fontSize: "8px",
                backgroundColor: "#FFEACC",
                padding: "13.5px",
              }}
            />
          </div>
        </div>

        {/* Modal */}
        <div
          className="modal fade"
          id={`modal-${i + team?.firstname}`}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby={`modalLabel-${i + team?.firstname}`}
          aria-hidden="true"
        >
          <div
            id="modal-dialog"
            className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
             data-aos="fade-up" data-aos-delay="200"
          >
            <div className="modal-content">
              <div id="modal-header" className="modal-header">
                <h5
                  className="modal-title"
                  id={`modalLabel-${i + team?.firstname}`}
                ></h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body d-flex justify-content-between align-items-start">
                <div
                  id="modal-container"
                  style={{ width: "20%", marginLeft: "20px" }}
                >
                  <img
                    src={team?.image.mediaItemUrl}
                    alt={team?.firstname + " " + team?.lastname}
                    className="modal-img"
                  />
                  <p
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "17.78px",
                      color: "#333333",
                      marginTop: "10px",
                    }}
                  >
                    {team?.firstname + " " + team?.lastname}
                  </p>
                  <p
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 400,
                      fontSize: "15.56px",
                      color: "#333333",
                      marginTop: "10px",
                    }}
                  >
                    {team?.role}
                  </p>
                </div>

                <div
                  className="modal-text-content"
                  style={{ width: "80%", overflowX: "scroll", height: "400px" }}
                >
                  <div class="modal-text">
                    <p>{team?.bio}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  });
  return (
    <>
      <div className="leadership-container d-block d-sm-none">
        {heroMobileBannerDisplay}
      </div>

      <div className="leadership-container d-none d-sm-block">
        {heroBannerDisplay}
      </div>
      <div className="Board-of-Directors">
        <div className="headers text-center pt-5">
          <p id="custom" className="orng-link "  data-aos="fade-up" data-aos-delay="200">
            OUR LEADERS
          </p>
          <h2 className="lead-h2"  data-aos="fade-up" data-aos-delay="200">Our Board of Directors</h2>
        </div>
      </div>
      <div id="containeer">
        <div className="card-divs mt-5 mb-5 d-flex justify-content-around  ">
          {LoopBoardMembers}
        </div>

        <div className="headers text-center mt-5">
          <p id="custom" className="orng-link "  data-aos="fade-up" data-aos-delay="200">
            OUR LEADERS
          </p>
          <h2 className="lead-h2"  data-aos="fade-up" data-aos-delay="200">Our Management Team</h2>
        </div>
        <div className="card-divs mt-5 mb-5 d-flex justify-content-around  ">
          {ManagementStaff}
        </div>
      </div>

       
      <Footer/>
           <div className='height'> 

              </div>
    </>
  );
};

export default Leadership;
